import React, { useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";

// index.html paints the page dark before React when this browser chose Dark (047 D110); the
// theme's own styles take over once it has drawn.
function DropBootStyle() {
  useEffect(() => {
    document.getElementById("mz-boot")?.remove();
  }, []);
  return null;
}

// Everyone starts in Light (047 D108); the choice is kept in this browser (D109). The app runs
// only in a browser, so `noSsr` reads the stored mode on the first render and the switch never
// shows the wrong half; the whole page changes colour at once. CssBaseline writes both modes'
// page colours (theme.js), so every page follows the switch (D106).
const ThemeRoot = ({ children }) => (
  <ThemeProvider theme={theme} defaultMode="light" noSsr disableTransitionOnChange>
    <CssBaseline enableColorScheme />
    <DropBootStyle />
    {children}
  </ThemeProvider>
);

export default ThemeRoot;
